import { render, staticRenderFns } from "./PlacesComponent.vue?vue&type=template&id=2cd72df0&"
import script from "./PlacesComponent.vue?vue&type=script&lang=js&"
export * from "./PlacesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports